export type OfferInput = {kind:'url';url:string}|{kind:'keyword';keyword:string}|{kind:'invalid';message:string};
export type OfferCandidate = {url:string;title:string};
export function parseOfferInput(input:string,website?:string|null):OfferInput{
 const value=input.trim();
 if(!value)return {kind:'invalid',message:'Enter a URL or keyword.'};
 if(value.length>2000)return {kind:'invalid',message:'Please use a shorter URL or keyword.'};
 const scheme=/^[a-z][a-z\d+.-]*:/i.test(value);
 const domain=/^[\w-]+(?:\.[\w-]+)+(?:[/:?#]|$)/.test(value);
 if(scheme||domain||value.startsWith('/')){
  try{
   const url=value.startsWith('/')?new URL(value,website||undefined):new URL(scheme?value:'https://'+value);
   if(!['https:','http:'].includes(url.protocol)||url.username||url.password)throw new Error();
   return {kind:'url',url:url.href};
  }catch{return {kind:'invalid',message:'Enter a valid website URL, or use a keyword such as Analytics.'};}
 }
 return {kind:'keyword',keyword:value};
}
